'use strict';

var StandardTileView = require('components/dashboard/views/standard_tile_view');

var WeatherTile = StandardTileView.extend({
    template: require('components/dashboard/templates/weather.hbs'),

    onShow: function () {
        var js,
            fjs = document.getElementsByTagName('script')[0];
        if (!document.getElementById('weatherwidget-io.js')) {
            js = document.createElement('script');
            js.id = 'weatherwidget-io-js';
            js.src = 'https://weatherwidget.io/js/widget.min.js';

            fjs.parentNode.insertBefore(js, fjs);
        }
    },
});

module.exports = {
    getTileView: function (options) {
        return new WeatherTile(options);
    },
};
